<template>
  <div>
    <div
      v-if="isShowing"
      ref="interactElement"
      :class="[
        {
          isAnimating: isInteractAnimating,
          isCurrent: isCurrent,
          blur:
            user_data.swipesLeft <= 0 ||
            (unlimitedPackageIsActive && !unlimitedPackageIsValid),
        },
      ]"
      class="card"
      :style="{ transform: transformString }"
    >
      <div
        class="overlay"
        :style="{ opacity: overlayAnimation, 'background-color': overlayColor }"
      >
        <v-icon v-if="interactPosition.x < 0">cancel</v-icon>
        <v-icon v-if="interactPosition.x > 0">check</v-icon>
      </div>
      <div>
        <div class="team-name mb-5">{{ card.team_name }}</div>

        <div class="logo-wrapper">
          <div
            class="logo"
            :style="{ backgroundImage: 'url(' + card.profile_pic + ')' }"
          >
            <div class="flag__floating flag__floating-team">
              <flag class="flag" :iso="card.nationality" />
            </div>
          </div>
        </div>

        <!-- <span class="d-block text-xs-center">{{card.nationality ? nationalitiesObj[card.nationality] : ''}}</span> -->
        <span class="d-block text-xs-center mt-4">
          <span style="color: green; font-weight: 300">Aktuelle Liga</span><br />
          <b>{{ card.category ? card.category.league : '' }}</b>
        </span>
        <span class="d-block text-xs-center">
          <span style="color: green; font-weight: 300">Region/Verband</span><br />
          <b>{{ card.verband ? card.verband : '' }}</b>
        </span>
      </div>
    </div>
    <!-- <div class="reject" @click="playCard('cardRejected')">
      <v-icon color="red">cancel</v-icon>
    </div>
    <div class="like" @click="playCard('cardAccepted')">
      <v-icon color="green">favorite</v-icon>
    </div> -->

    <div
      class="swipe-arrow swipe-arrow-left"
      @click="playCard('cardRejected')"
      v-if="user_data.swipesLeft > 0"
    >
      <div style="padding-bottom: 8px"><b>SWIPE</b></div>
      <span></span>
      <span></span>
      <span></span>
      <div><b>DISCONNECT*</b></div>
    </div>
    <div
      class="swipe-arrow swipe-arrow-right"
      @click="playCard('cardAccepted')"
      v-if="user_data.swipesLeft > 0"
    >
      <div style="padding-bottom: 8px"><b>SWIPE</b></div>
      <span></span>
      <span></span>
      <span></span>
      <div><b>CONNECT</b></div>
    </div>
  </div>
</template>

<script>
import interact from 'interact.js';
import { mapState } from 'vuex';
import matchPlayerTrainer from '@/mixins/match-player-trainer';

const ACCEPT_CARD = 'cardAccepted';
const REJECT_CARD = 'cardRejected';
const SKIP_CARD = 'cardSkipped';

export default {
  static: {
    interactMaxRotation: 15,
    interactOutOfSightXCoordinate: 500,
    interactOutOfSightYCoordinate: -600,
    interactYThreshold: -50,
    interactXThreshold: 20,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
    isCurrent: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
    },
  },

  data() {
    return {
      isShowing: true,
      isInteractAnimating: true,
      isInteractDragged: null,
      interactPosition: {
        x: 0,
        y: 0,
        rotation: 0,
      },
    };
  },

  mixins: [matchPlayerTrainer],

  computed: {
    ...mapState(['nationalitiesObj', 'user_data', 'payments']),

    transformString() {
      if (!this.isInteractAnimating || this.isInteractDragged) {
        const { x, y, rotation } = this.interactPosition;

        return `translate3D(${x}px, ${y}px, 0) rotate(${rotation}deg)`;
      }

      return null;
    },
    overlayAnimation() {
      const { x, y, rotation } = this.interactPosition;
      return Math.abs(x / 300);
    },
    overlayColor() {
      const { x, y, rotation } = this.interactPosition;
      if (x < 0) {
        return 'red';
      }
      if (x > 0) {
        return 'lightgreen';
      }
      return null;
    },
  },

  mounted() {
    const element = this.$refs.interactElement;

    interact(element).draggable({
      onstart: () => {
        this.isInteractAnimating = false;
      },

      onmove: (event) => {
        const { interactMaxRotation, interactXThreshold } = this.$options.static;
        const x = this.interactPosition.x + event.dx;
        const y = this.interactPosition.y + event.dy;

        let rotation = interactMaxRotation * (x / interactXThreshold);

        if (rotation > interactMaxRotation) rotation = interactMaxRotation;
        else if (rotation < -interactMaxRotation) rotation = -interactMaxRotation;
        this.interactSetPosition({ x, y, rotation });
        // console.log('move: ', x);
      },

      onend: () => {
        const { x, y } = this.interactPosition;
        const { interactXThreshold, interactYThreshold } = this.$options.static;
        this.isInteractAnimating = true;
        // console.log('end: ', x);
        if (x > interactXThreshold) this.playCard(ACCEPT_CARD);
        else if (x < -interactXThreshold) this.playCard(REJECT_CARD);
        else if (y < interactYThreshold) this.playCard(SKIP_CARD);
        else this.resetCardPosition();
      },
    });
  },

  beforeDestroy() {
    interact(this.$refs.interactElement).unset();
  },

  methods: {
    reject() {},
    hideCard() {
      setTimeout(() => {
        this.isShowing = false;
        this.$emit('hideCard', this.card);
      }, 500);
    },

    playCard(interaction) {
      const {
        interactOutOfSightXCoordinate,
        interactOutOfSightYCoordinate,
        interactMaxRotation,
      } = this.$options.static;

      this.interactUnsetElement();

      switch (interaction) {
        case ACCEPT_CARD:
          this.interactSetPosition({
            x: interactOutOfSightXCoordinate,
            rotation: interactMaxRotation,
          });
          this.$emit(ACCEPT_CARD);
          break;
        case REJECT_CARD:
          this.interactSetPosition({
            x: -interactOutOfSightXCoordinate,
            rotation: -interactMaxRotation,
          });
          this.$emit(REJECT_CARD);
          break;
        case SKIP_CARD:
        default:
          this.interactSetPosition({
            y: interactOutOfSightYCoordinate,
          });
          this.$emit(SKIP_CARD);
          break;
      }

      this.hideCard();
    },

    interactSetPosition(coordinates) {
      const { x = 0, y = 0, rotation = 0 } = coordinates;
      this.interactPosition = { x, y, rotation };
    },

    interactUnsetElement() {
      interact(this.$refs.interactElement).unset();
      this.isInteractDragged = true;
    },

    resetCardPosition() {
      this.interactSetPosition({ x: 0, y: 0, rotation: 0 });
    },
  },
};
</script>

<style>
.swipe-arrow {
  opacity: 0.4;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  cursor: pointer;
  text-align: center;
}

.swipe-arrow:hover {
  opacity: 1;
}

.swipe-arrow-left {
  left: 15px;
}

.swipe-arrow-right {
  right: 10px;
}

.swipe-arrow-left div {
  color: red;
}

.swipe-arrow-right div {
  color: green;
}

/* .swipe-arrow:hover span {
  animation: animate 2s infinite;
}
.swipe-arrow:hover span:nth-child(3){
    animation-delay: -0.4s;
}
.swipe-arrow:hover span:nth-child(2){
    animation-delay: -0.2s;
} */

.swipe-arrow div {
  margin-top: 8px;
  margin-left: -10px;
}

.swipe-arrow-right span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-bottom: 4px solid green;
  border-right: 4px solid green;
  transform: rotate(-45deg);
  margin: -5px;
  animation: animate 2s 3 ease-in-out;
}
.swipe-arrow-right span:nth-child(2) {
  animation-delay: 0.4s;
}
.swipe-arrow-right span:nth-child(3) {
  animation-delay: 0.2s;
}

.swipe-arrow-right span:last-of-type {
  margin-right: 10px;
}

.swipe-arrow-left span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-bottom: 4px solid red;
  border-right: 4px solid red;
  transform: rotate(135deg);
  margin: -5px;
  animation: animate_left 2s 3 ease-in-out;
  animation-delay: 0.6s;
}
.swipe-arrow-left span:nth-child(2) {
  animation-delay: 0.2s;
}
.swipe-arrow-left span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(-65deg) translate(-10px, -15px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(-35deg) translate(10px, 10px);
  }
}
@keyframes animate_left {
  0% {
    opacity: 0;
    transform: rotate(150deg) translate(-10px, -15px);
  }
  50% {
    opacity: 1;
    /* transform: rotate(140deg) translate(0px, 0px); */
  }
  100% {
    opacity: 0;
    transform: rotate(125deg) translate(10px, 10px);
  }
}
</style>
